import type { AlgoliaInsightsConfig } from '@maestro/algolia-insights/types'

/**
 * Get Algolia Insights configuration from environment variables
 */
export function getAlgoliaInsightsConfig(): AlgoliaInsightsConfig {
  const isEnabled = process.env.NEXT_PUBLIC_ALGOLIA_INSIGHTS_ENABLED === 'true'
  const isDebug = process.env.NEXT_PUBLIC_ALGOLIA_INSIGHTS_DEBUG === 'true'

  if (!isEnabled) {
    return {
      appId: '',
      apiKey: '',
      indexProducts: '',
      isEnabled: false,
      isDebug: false,
      cookieConsentNames: [],
    }
  }

  const appId = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID
  const apiKey = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY
  const indexProducts = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_PRODUCTS
  const indexArticles = process.env.NEXT_PUBLIC_ALGOLIA_INDEX_ARTICLES
  const cookieConsentNames = (
    process.env.NEXT_PUBLIC_ALGOLIA_COOKIE_CONSENT_NAMES ?? 'statistics'
  )
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)

  if (!appId || !apiKey || !indexProducts) {
    throw new Error(
      'Missing required Algolia configuration. Please set NEXT_PUBLIC_ALGOLIA_APP_ID, NEXT_PUBLIC_ALGOLIA_SEARCH_KEY, and NEXT_PUBLIC_ALGOLIA_INDEX_PRODUCTS environment variables.'
    )
  }

  return {
    appId,
    apiKey,
    indexProducts,
    indexArticles,
    isEnabled,
    isDebug,
    cookieConsentNames,
  }
}
